var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQThumbsUpRoundFill = function SvgQThumbsUpRoundFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 68 68"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 33.997,
    r: 28.333,
    fill: "#FFF8E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF8E1",
    fillRule: "evenodd",
    stroke: "#FFB300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.187,
    d: "M23.183 31.125v15l13.456 1.283a3.48 3.48 0 0 0 3.414-1.84l5.098-9.558c1.249-2.342-.424-5.188-3.051-5.188h-8.075c-.616 0-.97-.695-.622-1.208 1.568-2.3 4.177-7.283-.69-9.526l-.556 1.008c-1.754 3.176-3.38 6.258-8.974 9.927z",
    clipRule: "evenodd"
  })));
};
export { SvgQThumbsUpRoundFill as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjgiIGhlaWdodD0iNjgiIHZpZXdCb3g9IjAgMCA2OCA2OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzQuMDAwMyIgY3k9IjMzLjk5NzQiIHI9IjI4LjMzMzMiIGZpbGw9IiNGRkY4RTEiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMy4xODI2IDMxLjEyNDhWNDYuMTI0NkwzNi42Mzg5IDQ3LjQwODFDMzguMDM3OCA0Ny41NDg3IDM5LjM4NTIgNDYuODIxNiA0MC4wNTMgNDUuNTY4Mkw0NS4xNTEzIDM2LjAwOTZDNDYuMzk5NiAzMy42Njc2IDQ0LjcyNzIgMzAuODIxNSA0Mi4wOTk4IDMwLjgyMTVIMzQuMDI1NEMzMy40MDkxIDMwLjgyMTUgMzMuMDU0NCAzMC4xMjY2IDMzLjQwMzIgMjkuNjE0NEMzNC45NzA1IDI3LjMxNDYgMzcuNTgwMSAyMi4zMzE0IDMyLjcxMzYgMjAuMDg3OUwzMi4xNTY4IDIxLjA5NjJDMzAuNDAzMiAyNC4yNzE3IDI4Ljc3NzMgMjcuMzUzNyAyMy4xODI2IDMxLjAyMjlWMzEuMTI0OFoiIGZpbGw9IiNGRkY4RTEiIHN0cm9rZT0iI0ZGQjMwMCIgc3Ryb2tlLXdpZHRoPSIyLjE4Njk1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";